 package hk.com.vr360_demo2.webapp.component.editor_rewrite

import hk.com.vr360_demo2.webapp.component.marzipano.PanoramaSceneConfig
import hk.com.vr360_demo2.webapp.component.marzipano.PanoramaLinkHotspot
import hk.com.vr360_demo2.webapp.component.marzipano.PanoramaViewParameters
import hk.com.vr360_demo2.webapp.core.ui_state.NetworkState
import hk.com.vr360_demo2.webapp.core.ui_state.ProgressBarState

data class EditorRewriteState(
    val isLoading: Boolean = true,
    val scenes: List<PanoramaSceneConfig> = emptyList(),
    val activeSceneId: String? = null,
    val uid: String? = null,
    val networkState: NetworkState = NetworkState.Good,
) {
    val progressBarState: ProgressBarState
        get() = when {
            !isLoading -> ProgressBarState.Idle
            scenes.isEmpty() -> ProgressBarState.FullScreenLoading
            else -> ProgressBarState.MessageLoading("正在加載..")
        }
}

sealed interface EditorRewriteIntent {
    data object Refresh : EditorRewriteIntent
    data class SwitchScene(val sceneId: String) : EditorRewriteIntent
    data class UpdateScenes(val scenes: List<PanoramaSceneConfig>) : EditorRewriteIntent
    class ConfirmDeleteHotspotMock(
        val sceneId: String,
        val hotspotsForSave: List<PanoramaLinkHotspot>,
        val onSuccess: () -> Unit,
    ) : EditorRewriteIntent
    class SaveCurrentHotspotsMock(
        val sceneId: String,
        val hotspots: List<PanoramaLinkHotspot>,
        val onSuccess: () -> Unit,
    ) : EditorRewriteIntent
    class SaveCurrentInitialViewMock(
        val sceneId: String,
        val initialViewParameters: PanoramaViewParameters,
        val onSuccess: () -> Unit,
    ) : EditorRewriteIntent
}

sealed interface EditorRewriteAction {
    data object InitialLoad : EditorRewriteAction
}

sealed interface EditorRewriteMessage {
    data object Loading : EditorRewriteMessage
    data class LoadSuccess(
        val scenes: List<PanoramaSceneConfig>,
        val uid: String?,
    ) : EditorRewriteMessage
    data class LoadFailure(val message: String) : EditorRewriteMessage
    data class SceneSwitched(val sceneId: String) : EditorRewriteMessage
    data class ScenesUpdated(val scenes: List<PanoramaSceneConfig>) : EditorRewriteMessage
}

sealed interface EditorRewriteEffect
